<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<!--Changing Weapon Material-->
<app-itemMaterialArmor *ngIf="itemRoles.asArmor" [item]="itemRoles.asArmor" [craftingStation]="craftingStation"
    [customItemStore]="customItemStore"></app-itemMaterialArmor>
<app-itemMaterialShield *ngIf="itemRoles.asShield" [item]="itemRoles.asShield" [craftingStation]="craftingStation"
    [customItemStore]="customItemStore"></app-itemMaterialShield>
<app-itemMaterialWeapon *ngIf="itemRoles.asWeapon" [item]="itemRoles.asWeapon" [craftingStation]="craftingStation"
    [customItemStore]="customItemStore"></app-itemMaterialWeapon>
